import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import PermissionsManager from './PermissionsManger';
import SuccessIcon from '../../../../../svg/SuccessIcon';
import SuccessModal from '../../../../components/common/Modal/SuccessModal';
import { useGetAllPermissionsQuery, useUpdatePermissionsMutation } from '../../../../../store/services/admin/RoleService';
import { transformPermissionsFromBackend, transformPermissionsToBackend } from '../../../../../utils/utils';
import { showSuccessToast } from '../../../../components/PluginsMenu/Toastr/Toastr';

export const RolePermissions = () => {
  const { id } = useParams();
  const [permissions, setPermissions] = useState([]);
  const [updatedTreePermissions, setUpdatedTreePermissions] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const navigate = useNavigate();

  const { data, refetch } = useGetAllPermissionsQuery({ id });
  const [updatePermissions] = useUpdatePermissionsMutation();

  useEffect(() => {
    if (data?.data) {
      const transformed = transformPermissionsFromBackend(data.data);
      setPermissions(transformed);
      setUpdatedTreePermissions(transformed);
    }
  }, [data?.data]);

  const handlePermissionsChange = (updatedPermissions) => {
    setUpdatedTreePermissions(updatedPermissions);
  };

  const handleSave = async () => {
    
    const backendFormattedPermissions = transformPermissionsToBackend(updatedTreePermissions);
    const response = await updatePermissions({ id, backendFormattedPermissions });

    if (response?.data?.succeeded) {
      showSuccessModal && setShowSuccessModal(false);
      showSuccessToast("Permissions updated successfully");
      navigate('/roles');
      setPermissions(updatedTreePermissions);
      await refetch();
    }
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    navigate('/roles');
  };

  return (
    <div className="container-fluid py-3">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header bg-primary py-3">
              <h4 className="mb-0 text-white">Edit Role Permissions</h4>
            </div>
            <div className="ms-3 mt-3">
              <p className="text-muted mb-3">
                Select the permissions you want to assign to this role.
              </p>

              <PermissionsManager
                initialPermissions={permissions}
                onChange={handlePermissionsChange}
              />
            </div>

            <div className="d-flex justify-content-center pb-4">
              <Link to="/roles" className="btn btn-light me-2">Cancel</Link>
              <button className="btn btn-primary" onClick={handleSave}>Save</button>
            </div>
          </div>
        </div>
      </div>

      <SuccessModal
        isOpen={showSuccessModal}
        onClose={handleSuccessModalClose}
        title="Success"
        message="Role permissions have been updated successfully!"
        icon={<SuccessIcon size={32} className="text-success" />}
      />
    </div>
  );
};

export default RolePermissions;